import styled from 'styled-components';

export const ButtonGroupDiv = styled.div`
    border: ${({ theme }) => `1px solid ${theme.colors.primary300}`};
    border-radius: 5px;
    width: ${({ width }) => width}px;
    height: 28px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    margin-bottom: ${({ marginBottom }) => marginBottom}px;
`;

export const Button = styled.button`
    height: 28px;
    color: ${({ selected, ind, theme }) => ((selected === ind) ? theme.colors.white : theme.colors.primary300)};
    background-color: ${({ selected, ind, theme }) => ((selected === ind) ? theme.colors.primary300 : 'transparent')};
    font-weight: bold;
    outline: none;
    border-top-left-radius: ${({ ind }) => (ind === 0 ? '5px' : '0px')};
    border-bottom-left-radius: ${({ ind }) => (ind === 0 ? '5px' : '0px')};
    border-top-right-radius: ${({ ind, last }) => (ind === last ? '5px' : '0px')};
    border-bottom-right-radius: ${({ ind, last }) => (ind === last ? '5px' : '0px')};
    border: none;
    border-left: ${({ index, theme }) => (index !== 0 ? `1px solid ${theme.colors.primary300}` : 'none')};
    box-sizing: border-box;
    width: ${({ width }) => width}px;
    cursor: pointer;

    &:focus {
        outline: ${({ theme }) => `solid ${theme.colors.primary300}`};
    }
`;
